import React from "react";
import classes from "./Intro.module.css";
import img from "../../images/Mert3.jpeg";

const Intro = (props) => {
  return (
    <div className={classes.intro}>
      <img className={classes.img} src={img}></img>
      <div className={classes.textContainer}>
        <h2>Mert Karaca</h2>
        <p className={classes.p}>
          With two years of experience, a detail-oriented and performancefocused
          frontend web developer. Passionate about solving complex problems and
          creating engaging user experiences using modern frontend technologies.
          Demonstrates strong problem-solving skills and works well as a team
          player.
        </p>
      </div>
    </div>
  );
};

export default Intro;
